import { render, staticRenderFns } from "./CustomerYearlyReport.vue?vue&type=template&id=aa46f6b4&scoped=true&"
import script from "./CustomerYearlyReport.vue?vue&type=script&lang=js&"
export * from "./CustomerYearlyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa46f6b4",
  null
  
)

export default component.exports